import React, { useEffect, useState } from "react";
import { Box, Card, Typography } from "@mui/material";
import api from "../../utils/api";

const STATUS_COLORS = { Resolved: "#16a34a", Open: "#2f63ad", "In Progress": "#b45309", Cancel: "#9aa5b4" };

// "Work orders by status" bar-list panel, sitting alongside the by-month
// trend charts. Uses the same real status vocabulary as the summary card's
// segmented bar (Open / In Progress / Cancel), plus Resolved as its own row.
const WorkOrdersStatusList = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get("/dashboard/module-summary").then((res) => setSummary(res.data?.workorders)).catch(() => {});
  }, []);

  if (!summary) return null;

  const rows = [
    { label: "Resolved", count: summary.resolved },
    ...summary.statusBreakdown.map((s) => ({ label: s.status, count: s.count })),
  ];
  const maxCount = Math.max(...rows.map((r) => r.count), 1);
  const resolutionRate = summary.total ? Math.round((summary.resolved / summary.total) * 100) : 0;

  return (
    <Card sx={{ borderRadius: "16px", p: 2.5, border: "1px solid rgba(0,0,0,0.06)", boxShadow: "0 4px 16px rgba(0,0,0,0.04)", height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#223142" }}>Work orders by status</Typography>
        <Typography variant="caption" sx={{ color: "#9aa5b4", fontWeight: 700, letterSpacing: 0.5 }}>ALL TIME</Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {rows.map((r) => (
          <Box key={r.label}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.4 }}>
              <Typography variant="body2" sx={{ color: "#223142", fontWeight: 600 }}>{r.label}</Typography>
              <Typography variant="body2" sx={{ color: "#223142", fontWeight: 700 }}>{r.count}</Typography>
            </Box>
            <Box sx={{ height: 8, borderRadius: "4px", backgroundColor: "rgba(0,0,0,0.05)", overflow: "hidden" }}>
              <Box sx={{
                width: `${(r.count / maxCount) * 100}%`, height: "100%", borderRadius: "4px",
                backgroundColor: STATUS_COLORS[r.label] || "#9aa5b4",
              }} />
            </Box>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2.5, pt: 1.5, borderTop: "1px solid rgba(0,0,0,0.06)" }}>
        <Typography variant="caption" sx={{ color: "#6b778c" }}>{resolutionRate}% resolution rate</Typography>
        <Typography variant="caption" sx={{ color: "#6b778c" }}>{summary.total} total</Typography>
      </Box>
    </Card>
  );
};

export default WorkOrdersStatusList;
